import { env } from './env'

const fallbackSiteUrl = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'

export const siteConfig = {
  siteName: 'Syria Bus Transport',
  siteUrl: env.siteUrl || fallbackSiteUrl,
  defaultLocale: 'ar' as const,
  supportedLocales: ['ar', 'en'] as const,
  themeColor: '#131313',
} as const

export function absoluteSiteUrl(path: string) {
  if (/^https?:\/\//.test(path)) return path
  return `${siteConfig.siteUrl}${path.startsWith('/') ? path : `/${path}`}`
}
